'use client';

import React, { forwardRef, useRef } from 'react';
import clsx from 'clsx';
import { Copyright } from '../../component/Copyright';
import './Footer.scss';

interface FooterProps {
    children: React.ReactNode;
    isEditingMode?: boolean;
    isBuyer?: boolean;
}

export const Footer = forwardRef<HTMLDivElement, FooterProps>((props, ref) => {
    const { children, isEditingMode, isBuyer = false } = props;

    const footerRef = useRef<HTMLDivElement>(null);

    return (
        <footer
            ref={footerRef}
            className={clsx('footer-container', {
                'footer-container--editing': isEditingMode,
            })}
            data-section-footer
            data-shop-component-footer
            data-layout-root
        >
            <div className="footer" ref={ref}>
                {children}
            </div>
            <Copyright isBuyer={isBuyer} />
        </footer>
    );
});

Footer.displayName = 'Footer';
